import { TipoEspecialidade } from './tipo-especialidade.model';

/**
 * Modelo de classe para representar os prestadores.
 */
export class Prestador {
    id: number;
    nome: string;
    razaoSocial: string;
    documento: string;
    status: boolean;
    tipoEspecialidade: TipoEspecialidade;
    codigo: string;
}
